document.addEventListener('click', e => {
  const b = e.target.closest('[data-br-menu]');
  if (b) {
    const n = document.querySelector('[data-br-nav]');
    n?.classList.toggle('is-open');
    b.setAttribute('aria-expanded', n?.classList.contains('is-open') ? 'true' : 'false');
    return;
  }

  const caret = e.target.closest('[data-br-caret]');
  if (caret) {
    e.preventDefault();
    const item = caret.closest('[data-br-submenu-item]');
    const wasOpen = item.classList.contains('is-open');

    document.querySelectorAll('[data-br-submenu-item].is-open').forEach(el => {
      if (el !== item) {
        el.classList.remove('is-open');
        el.querySelector('[data-br-caret]')?.setAttribute('aria-expanded', 'false');
      }
    });

    item.classList.toggle('is-open', !wasOpen);
    caret.setAttribute('aria-expanded', !wasOpen ? 'true' : 'false');
    return;
  }

  if (!e.target.closest('[data-br-submenu-item]')) {
    document.querySelectorAll('[data-br-submenu-item].is-open').forEach(el => {
      el.classList.remove('is-open');
      el.querySelector('[data-br-caret]')?.setAttribute('aria-expanded', 'false');
    });
  }
});

document.addEventListener('shopify:section:load', () => {
  document.querySelector('[data-br-nav]')?.classList.remove('is-open');
  document.querySelectorAll('[data-br-submenu-item].is-open').forEach(el => el.classList.remove('is-open'));
});